import React, { memo, useState } from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// form fields
import AppFormikRadio from 'utlis/helpers/forms/AppFormikRadio'

// app inputs
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'
import AppFormikTextarea from 'utlis/helpers/forms/AppFormikTextarea';

function FormRibbon(props) {
    // props
    const {
        formik,

        ribbonColors
    } = props

    // states
    const [ribbonFieldVisible, setRibbonFieldVisible] = useState(false)
    const [showMoreOptionVisible, setShowMoreOptionVisible] = useState(false)

    // handleColorChange
    const handleColorChange = color => {
        if (color) {
            setRibbonFieldVisible(false)
            formik.setFieldValue("ribbonColor", color)
        }
    }

    // handleColorChange
    const handleRibbonFieldVisibility = () => {
        setRibbonFieldVisible(true)

        formik.setFieldValue("ribbonColor", formik.getFieldProps("ribbonColor").value)
    }

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {
                        (formik.getFieldProps("hasRibbon").value) ? (
                            <div className="add-ribbon-view">
                                <div className="arv-inner d-flex flex-wrap">
                                    {/* form */}
                                    <div className="form-view d-flex flex-column">
                                        {/* form field */}
                                        <AppFormikInput
                                            inputType={"text"}
                                            formik={formik} // formik object
                                            stFormClass={"ribbon-name-field"} // class name for main wrapper
                                            labelName={"Ribbon Text"} // label name
                                            // isRequired={true} // is this field is required or not to show the red star sign
                                            placeholder={"Ribbon Text"} // placeholder for the input
                                            formikFieldName={"ribbonText"} // important: formik value name for the input
                                        />

                                        <div className="ribbon-color-container pt-2">

                                            <div className="ribbon-pre-defined-colors d-flex flex-wrap">
                                                {
                                                    ribbonColors?.length && ribbonColors.map((color, index) => (
                                                        <div
                                                            key={index}
                                                            className={`color-item cursor-pointer ${formik.getFieldProps("ribbonColor").value === color ? 'active' : ''}`}
                                                            onClick={() => handleColorChange(color)}
                                                            style={{ backgroundColor: color }}
                                                        ></div>
                                                    ))
                                                }
                                                <div
                                                    className="color-item custom-color cursor-pointer d-flex align-items-center justify-content-center"
                                                    onClick={handleRibbonFieldVisibility}
                                                    style={{ backgroundColor: '#fff' }}
                                                >
                                                    <span className="st-fs-20">#</span>
                                                </div>
                                            </div>

                                            {
                                                ribbonFieldVisible ? (
                                                    <div className="ribbon-color-field-container">
                                                        {/* form field */}
                                                        <AppFormikInput
                                                            inputType={"text"}
                                                            formik={formik} // formik object
                                                            stFormClass={"ribbon-color-field"} // class name for main wrapper
                                                            // labelName={"Ribbon Color"} // label name
                                                            // isRequired={true} // is this field is required or not to show the red star sign
                                                            placeholder={"Ribbon Color"} // placeholder for the input
                                                            formikFieldName={"ribbonColor"} // important: formik value name for the input
                                                        />
                                                    </div>
                                                ) : null
                                            }
                                        </div>


                                        <div className="btns py-3 d-flex align-items-center mt-auto">
                                            <a href="/" className="text-decoration-none d-flex align-items-center st-text-danger st-fs-15 me-3" onClick={(ev) => {
                                                ev.preventDefault()
                                                formik.setFieldValue("hasRibbon", false)
                                            }}>
                                                <FeatherIcon
                                                    icon="trash-2"
                                                    size="15"
                                                    className="icon me-2"
                                                />
                                                <span>Remove Ribbon</span>
                                            </a>
                                            <a href="/" className="text-decoration-none d-flex align-items-center st-text-primary st-fs-15" onClick={(ev) => {
                                                ev.preventDefault()
                                                // resetting more options values
                                                formik.setFieldValue("ribbonDisableToCart", false)
                                                formik.setFieldValue("ribbonDisableDescription", "")
                                                formik.setFieldValue("ribbonPosition", "on_image")

                                                if (showMoreOptionVisible) {
                                                    setShowMoreOptionVisible(false)
                                                } else {
                                                    setShowMoreOptionVisible(true)
                                                }
                                            }}>
                                                {
                                                    showMoreOptionVisible ? (
                                                        <span>Hide More Options</span>
                                                    ) : (
                                                        <span>Show More Options</span>
                                                    )
                                                }
                                                <FeatherIcon
                                                    icon={showMoreOptionVisible ? "chevrons-up" : "chevrons-down"}
                                                    size="15"
                                                    className="icon ms-2"
                                                />
                                            </a>
                                        </div>

                                        {/* more options */}
                                        {
                                            showMoreOptionVisible ? (
                                                <div className="show-more-ribbon-options">
                                                    {/* heading */}
                                                    <p className="box-heading st-fs-17 st-fw-600 st-text-primary mb-2">More ribbon options</p>

                                                    {/* frac */}
                                                    <div className="frac mb-2">
                                                        <div className="d-flex align-items-center mb-2">
                                                            {/* heading */}
                                                            <p className="box-heading st-fs-15 st-fw-600 st-text-color me-3">Disable add to cart</p>
                                                            {/* form field */}
                                                            <AppFormikRadio
                                                                formik={formik} // formik object
                                                                labelClass={"align-items-center mb-0"} // class name for main wrapper
                                                                checkedText={"Enabled"} // name when the radio is checked
                                                                unCheckedText={"Disabled"} // name when the radio is checked
                                                                // isRequired={true} // is this field is required or not to show the red star sign
                                                                formikFieldName={"ribbonDisableToCart"} // important: formik value name for the input
                                                            />
                                                        </div>

                                                        {
                                                            formik.values.ribbonDisableToCart ? (
                                                                <AppFormikTextarea
                                                                    formik={formik} // formik object
                                                                    stFormClass={"mb-0"} // class name for main wrapper
                                                                    labelName={"Disable Cart Description (optional)"} // label name
                                                                    placeholder={"Disable Cart Description (optional)"} // placeholder for the input
                                                                    textareaRows={"3"} // rows for textarea
                                                                    formikFieldName={"ribbonDisableDescription"} // important: formik value name for the input
                                                                />
                                                            ) : null
                                                        }
                                                    </div>

                                                    {/* frac */}
                                                    <div className="frac mb-2">
                                                        <p className="st-fs-13 st-fw-600 st-text-color2 mb-2">Ribbon Position</p>

                                                        <div className="st-from-group d-flex align-items-center">
                                                            {/* radio */}
                                                            <label className="st-custom-radio d-flex align-items-center me-3">
                                                                <input
                                                                    type="radio"
                                                                    className="d-none"
                                                                    name="ribbon_position"
                                                                    checked={formik.getFieldProps("ribbonPosition").value === "on_image" ? true : false}
                                                                    onChange={() => formik.setFieldValue("ribbonPosition", "on_image")}
                                                                />
                                                                <span className="round"><span className="inner"></span></span>
                                                                {/* text */}
                                                                <span className="text media-body position-relative" style={{ top: 2.3 }}>
                                                                    On Image
                                                                </span>
                                                            </label>

                                                            {/* radio */}
                                                            <label className="st-custom-radio d-flex align-items-center me-2">
                                                                <input
                                                                    type="radio"
                                                                    className="d-none"
                                                                    name="ribbon_position"
                                                                    checked={formik.getFieldProps("ribbonPosition").value === "under_imaage" ? true : false}
                                                                    onChange={() => formik.setFieldValue("ribbonPosition", "under_imaage")}
                                                                />
                                                                <span className="round"><span className="inner"></span></span>
                                                                {/* text */}
                                                                <span className="text media-body position-relative" style={{ top: 2.3 }}>
                                                                    Under Image
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                    </div>


                                    {/* preview */}
                                    <div className={`preview-sec ${formik.getFieldProps("ribbonPosition").value === "on_image" ? "position_on-image" : "position_under-image"}`}>
                                        <div className="inner ms-auto d-flex position-relative">
                                            <div className="ribbon-stripe position-absolute"
                                                style={{ backgroundColor: formik.getFieldProps("ribbonColor").value || "red", color: '#fff' }}>
                                                {
                                                    formik.getFieldProps("ribbonText").value || "Your Text"
                                                }
                                            </div>
                                            {/* {
                                                formik.getFieldProps("ribbonText").value?.length ? (
                                                ) : null
                                            } */}

                                            <p className="text align-self-end st-fs-13 text-center w-100 mb-1">Ribbon Preview</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* heading */}
                                <p className="box-heading st-fs-15 st-fw-600 st-text-color me-3 mb-2">
                                    <span className="st-text-primary me-2">Add or edit ribbon</span>
                                    <span className="round-feather-icon-with-bg hoverable d-inline-flex align-items-center justify-content-center">
                                        <FeatherIcon
                                            icon="plus"
                                            size="12"
                                            className="icon cursor-pointer"
                                            onClick={() => formik.setFieldValue("hasRibbon", true)}
                                        />
                                    </span>
                                </p>
                                <p className="st-fs-13 st-text-color2">Place customized text labels line "New" or "Free Shipping" over the main product image to attract customers and bring in more sales.</p>
                            </>
                        )
                    }
                </div>
            </div>
        </React.Fragment>
    )
}


export default memo(FormRibbon)